import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { FadeInUp } from '../animations';
import { categoryList } from '../../data/categoryData';

const CategoriesSection = () => (
  <section className="py-24 lg:py-32 bg-[#fafaf9]" data-testid="categories-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <FadeInUp className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
          ONE SOURCING PARTNER.<br className="hidden sm:block" />
          MULTIPLE CATEGORIES.
        </h2>
      </FadeInUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {categoryList.map((cat, i) => (
          <FadeInUp key={cat.slug} delay={i * 0.05}>
            <Link to={`/categories/${cat.slug}`}>
              <motion.div
                whileHover={{ y: -4 }}
                transition={{ duration: 0.2 }}
                className="group relative overflow-hidden bg-white border border-[#E5E0D8]/60 hover:shadow-lg transition-all"
                data-testid={`category-card-${cat.slug}`}
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={cat.image} alt={cat.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-[#0B2A57] mb-1" style={{ fontFamily: 'Cabinet Grotesk' }}>{cat.title}</h3>
                  <p className="text-xs text-[#6B7280] leading-relaxed">{cat.shortDescription}</p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-[#1E3D66] tracking-wider uppercase group-hover:gap-2 transition-all">
                    Explore <ArrowRight size={14} />
                  </span>
                </div>
              </motion.div>
            </Link>
          </FadeInUp>
        ))}
      </div>
    </div>
  </section>
);

export default CategoriesSection;
